import { Typography } from '@mui/joy';

import { Button } from '~/components/ui/button';
import { Dialog, DialogContent } from '~/components/ui/dialog';

export default function DialogAlertWithTrigger({
  open,
  handleClose,
  headerText,
  alertText,
}: Readonly<{
  open: boolean;
  handleClose: () => void;
  headerText: string;
  alertText: string;
}>) {
  return (
    <Dialog modal open={open} onOpenChange={handleClose}>
      <DialogContent size='sm' className='flex flex-col gap-2'>
        <Typography level='title-lg'>{headerText}</Typography>
        <Typography level='body-md'>{alertText}</Typography>
        <Button
          variant='outlined'
          shape='pill'
          color='gradient-primary'
          onClick={handleClose}
        >
          Done
        </Button>
      </DialogContent>
    </Dialog>
  );
}
